angular.module('cfn').directive('cfnAmazoneMachineSettings', [
  '$rootScope',
  function($rootScope) {
    return {
      restrict: 'E',
      templateUrl: require('./amazoneMachineSettingsDirective.html')
    };
  }
]);
